import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { IAuthProvider, ICreateAuthProvider } from './auth-provider.interface'
import { HttpErrorHandlerService } from '../helpers/http-error-handler.service'
import { IUpdateDTModel } from '../helpers/update-model.interface'
import { catchError, firstValueFrom } from 'rxjs'
import { API_ENDPOINT_PATH, API_HTTP_HEADERS } from "../helpers/api-constant";



@Injectable({
  providedIn: 'root'
})
export class AuthProviderService {
  readonly #headers: HttpHeaders
  readonly #urlEndpoint: string

  constructor(
    private readonly http: HttpClient,
    private readonly errorHandlerService: HttpErrorHandlerService
  ) {
	  this.#urlEndpoint = `${API_ENDPOINT_PATH}/authProvider`;
	  this.#headers = new HttpHeaders(API_HTTP_HEADERS);
  }

  private getUrl(): string {
    return `${this.#urlEndpoint}`
  }

  private getHeader(): HttpHeaders {
    return this.#headers
  }

  async upsertOne(payload: IAuthProvider|ICreateAuthProvider): Promise<IAuthProvider|IUpdateDTModel|{}> {
    const result = this.http.post<IAuthProvider>(`${this.getUrl()}`, payload,
      { headers: this.getHeader() }).pipe(catchError(this.errorHandlerService.handleErrorForSingleRecord))
    return await firstValueFrom(result)
  }

  async getById(id: string, attr?: string): Promise<IAuthProvider|{}> {
    let queryUrl = `${this.getUrl()}/${id}`
    if (attr) { queryUrl += `?attr=${attr}`}

    const result = this.http.get<IAuthProvider|{}>(`${queryUrl}`,
      { headers: this.getHeader() }).pipe(catchError(this.errorHandlerService.handleErrorForSingleRecord))
    return await firstValueFrom(result)
  }

  async listAll(params?: string): Promise<IAuthProvider[]> {
    let queryUrl = `${this.getUrl()}`
    if (params) { queryUrl += `?${params}` }

    const result = this.http.get<IAuthProvider[]>(`${queryUrl}`,
      { headers: this.getHeader() }).pipe(catchError(this.errorHandlerService.handleErrorForRecords))
    return await firstValueFrom(result)
  }

  async deleteById(id: string): Promise<void> {
	  const headers = this.getHeader().delete('Content-Type').delete('content-type');

    const result = this.http.delete(`${this.getUrl()}/${id}`,
      { headers: headers }).pipe(catchError(this.errorHandlerService.handleError))
    await firstValueFrom(result)
  }
}
